import { type ChangeEvent } from 'react'
import { addToArray } from '../../../../shared/utils/arrayUtils'
import { RECURRING_FREQUENCY_SELECT_OPTIONS } from '../../../../shared/types/RecurringFrequencyType'
import { type GlobalReactSelectOptionStringValueType } from '../../../../shared/types/GlobalReactSelectOptionStringValueType'
import { recurringPaymentNewProxy } from './recurringPaymentNewProxy'
import { RecurringPaymentNewProxyFormFieldNamesEnum } from './recurringPaymentNewProxyFormFieldNamesEnum'
import { validators } from './validators'
import { normalizers } from './normalizers'

export const buildFrequencyOption = (billingCycle: string): { label: string, value: string } | null => {
  const option = RECURRING_FREQUENCY_SELECT_OPTIONS.find((opt) => opt.value === billingCycle)
  return option ? { label: option.label, value: option.value } : null
}

export const handleFrequencyChange = (selectedOption: GlobalReactSelectOptionStringValueType | null): void => {
  if (selectedOption) {
    recurringPaymentNewProxy.form.values.billingCycle = selectedOption?.value
    recurringPaymentNewProxy.form.dirty = addToArray(recurringPaymentNewProxy.form.dirty, RecurringPaymentNewProxyFormFieldNamesEnum.BillingCycle)
  }
}

export const handleChange = (fieldName: RecurringPaymentNewProxyFormFieldNamesEnum) => (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
  // @ts-expect-error
  const val: string = e.target.type === 'checkbox' ? e.target.checked : e.target.value
  const normalizer = normalizers[fieldName]
  const normalized = normalizer ? normalizer(val) : val
  recurringPaymentNewProxy.form.values[fieldName] = normalized
  recurringPaymentNewProxy.form.dirty = addToArray(recurringPaymentNewProxy.form.dirty, fieldName)
  const validator = validators[fieldName]
  if (validator) { recurringPaymentNewProxy.form.errors[fieldName] = validator(normalized) }
}

export const handleBlur = (fieldName: RecurringPaymentNewProxyFormFieldNamesEnum) => () => {
  recurringPaymentNewProxy.form.blurred = addToArray(recurringPaymentNewProxy.form.blurred, fieldName)
}
